/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'ca-content/common-home/HomeView',
	'../nls/StringResources',
	'ca-content/home/caHome',
	'react',
	'react-dom'
], function(HomeView, StringResources, caHome, React, ReactDOM) {

	class CAHomeView extends HomeView {
		constructor(options) {
			super(options);
			if (options.folder) {
				this.redirectToContentPage(options.folder);
			}
			this.uploadHelper = new caHome.UploadHelper({ glassContext: this.glassContext });
			this.dragEnterTargets = [];
			this.showUpload = false;
			this._initializeContentService();
		}

		_initializeContentService() {
			this.glassContext.getSvc('.Content');
		}

		redirectToContentPage(pathRef) {
			this.glassContext.openAppView('content', {
				content: {
					folder: pathRef
				}
			});
		}

		render() {
			return super.render().then(() => {
				this.uploadContainerNode = document.createElement('div');
				this.el.appendChild(this.uploadContainerNode);
				return this._renderUpload();
			});
		}

		_getAdditionalParameters() {
			return {
				uploadHelper: this.uploadHelper
			};
		}

		_renderUpload() {
			return this.uploadHelper.initialize().then(() => {
				const options = {
					glassContext: this.glassContext,
					uploadHelper: this.uploadHelper,
					showUpload: this.showUpload,
					hideQuickLaunch: this._hideUpload.bind(this)
				};
				ReactDOM.render(React.createElement(caHome.Upload, options), this.uploadContainerNode);
				return Promise.resolve();
			});
		}

		_setUploadVisibility(showUpload) {
			if (showUpload !== this.showUpload) {
				this.showUpload = showUpload;
				this._renderUpload();
			}
		}

		_hideUpload() {
			this.dragEnterTargets = [];
			this._setUploadVisibility(false);
		}

		_registerDragEnterEvent (target) {
			let targetContainer = target;
			let registerTarget = true;
			let classes;
			do {
				classes = targetContainer.classList;
				if (classes && classes.contains('homeView')) {
					registerTarget = false;
					break;
				} else if (classes && classes.contains('ca-uploadContent')) {
					break;
				}
				targetContainer = targetContainer.parentElement;
			} while (targetContainer);
			if (registerTarget) {
				this.dragEnterTargets.push(target);
			}

			this._setUploadVisibility(true);
		}

		_registerDragLeaveEvent (target) {
			let targetsStillEntered = [];

			// See what targets you have left from dragging over and remove them from state
			let i;
			let oldTarget;
			for (i = 0; i < this.dragEnterTargets.length; i++) {
				oldTarget = this.dragEnterTargets[i];
				if (oldTarget !== target) {
					targetsStillEntered.push(oldTarget);
				}
			}
			this.dragEnterTargets = targetsStillEntered;

			// If you are no longer hovering over items, hide the quick upload
			if (targetsStillEntered.length === 0) {
				this._setUploadVisibility(false);
			}
		}

		_onDragOver(e) {
			e.preventDefault();
			e.stopPropagation();
		}

		_onDragEnter(e) {
			// Retrieve the data file
			const data = this.uploadHelper.getDataFromEvent(e);

			// Check if you can download
			if (this.uploadHelper.allowUploadFiles() && this.uploadHelper.hasFiles(data)) {
				this._registerDragEnterEvent(e.target);
			}
		}

		_onDragLeave(e) {
			if (this.uploadHelper.allowUploadFiles()) {
				this._registerDragLeaveEvent(e.target);
			}
		}

		_initDomElement() {
			const el = document.createElement('div');
			el.addEventListener('dragover', this._onDragOver.bind(this));
			el.addEventListener('dragenter', this._onDragEnter.bind(this));
			el.addEventListener('dragleave', this._onDragLeave.bind(this));
			el.addEventListener('dragend', this._onDragLeave.bind(this));
			el.classList.add('homeView');
			return el;
		}

		getTitle() {
			return StringResources.get('homePageTitleLabel');
		}

	}
	return CAHomeView;
});